import React from "react";
import { getProgressPercentage, normalizeProgressValue } from "../helpers";
import Circle from "./Circle";
import ConditionalOutsideSublabel from "./ConditionalOutsideSublabel";
import ProgressCircleInsideLabels from "./ProgressCircleInternalLabels";
import { getProgressCircleSizeStyles } from "./helpers";
import * as S from "./styled";
import { ProgressCircleProps } from "./types";

const ProgressCircle = ({
    value,
    minValue = 0,
    maxValue = 100,
    size = "xs",
    label = `${normalizeProgressValue(value, minValue, maxValue).toFixed()}%`,
    sublabel,
    progressColor = "primary-800",
    progressBackgroundColor = "primary-50",
    labelColor = "primary-1200",
    sublabelColor = "primary-700"
}: ProgressCircleProps) => {
    const { size: styleSize } = getProgressCircleSizeStyles(size);

    return (
        <ConditionalOutsideSublabel size={size} sublabel={sublabel} sublabelColor={sublabelColor}>
            <S.CircleWrapper $size={styleSize}>
                <Circle
                    size={size}
                    progress={getProgressPercentage(value, minValue, maxValue)}
                    progressColor={progressColor}
                    progressBackgroundColor={progressBackgroundColor}
                />
                <ProgressCircleInsideLabels
                    size={size}
                    label={typeof label === "string" ? label : label(value, minValue, maxValue)}
                    labelColor={labelColor}
                    sublabel={sublabel}
                    sublabelColor={sublabelColor}
                />
            </S.CircleWrapper>
        </ConditionalOutsideSublabel>
    );
};

export default ProgressCircle;
